import { useState, useEffect } from 'react';
import type { ServiceType } from '@/pages/home/hooks/useWhatsApp';

interface HeaderProps {
  onOpenWhatsApp: (service?: ServiceType) => void;
}

export default function Header({ onOpenWhatsApp }: HeaderProps) {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Hizmetler', href: '#hizmetler' },
    { label: 'Kimlere Hizmet Veriyoruz?', href: '#kimlere' },
    { label: 'Neden Kaya Catering?', href: '#neden' },
    { label: 'Teklif Al', href: '#teklif' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          <a href="#" className="flex items-center gap-2">
            <h1>
              <span
                className={`font-heading text-2xl md:text-3xl tracking-wider transition-colors ${
                  scrolled ? 'text-primary-600' : 'text-primary-400'
                }`}
              >
                KAYA CATERING
              </span>
            </h1>
          </a>

          <nav className="hidden md:flex items-center gap-6">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className={`font-label text-sm font-medium transition-colors hover:text-primary-500 ${
                  scrolled ? 'text-foreground-800' : 'text-foreground-100'
                }`}
              >
                {link.label}
              </a>
            ))}
            <button
              onClick={() => onOpenWhatsApp()}
              className="btn-primary text-xs"
            >
              <i className="ri-whatsapp-line text-base"></i>
              WhatsApp&apos;tan Teklif Al
            </button>
          </nav>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center transition-colors ${
              scrolled ? 'text-foreground-950' : 'text-foreground-50'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Menu"
          >
            <i
              className={`text-2xl ${
                mobileOpen ? 'ri-close-line' : 'ri-menu-line'
              }`}
            ></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-lg border-t border-background-200">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMobileOpen(false)}
                className="text-foreground-800 font-label text-sm font-medium py-2 hover:text-primary-600"
              >
                {link.label}
              </a>
            ))}
            <button
              onClick={() => {
                setMobileOpen(false);
                onOpenWhatsApp();
              }}
              className="btn-primary w-full mt-2 text-sm"
            >
              <i className="ri-whatsapp-line text-base"></i>
              WhatsApp&apos;tan Teklif Al
            </button>
          </div>
        </div>
      )}
    </header>
  );
}